import getWindowSize from '@/utils/window-size'

export default {
  data() {
    return {
      size: getWindowSize(),
    }
  },
  computed: {
    isMobile() {
      return this.size.isMobile
    },
    isTablet() {
      return this.size.isTablet
    },
    isTabletDown() {
      return this.isTablet || this.isMobile
    },
    isDesktop() {
      return this.size.isDesktop
    },
    screenWidth() {
      return this.size.width
    },
  },
  created() {
    window.addEventListener('resize', this.handleWindowChangedSize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowChangedSize)
  },
  methods: {
    handleWindowChangedSize() {
      this.size = { ...getWindowSize() }
    },
  },
}
